module.exports = __webpack_public_path__ + "img/refresh.4d78ef04.svg";